import angular from 'angular';
import tableGridRowComponent from './tableGridRow.component';

let tableGridRowModule = angular.module('tableGridRow', []).directive('tableGridRow', tableGridRowComponent);

export default tableGridRowModule;



// WEBPACK FOOTER //
// ./app/components/tableGridRow/tableGridRow.js